import { Model } from "../Model";

export interface Culture extends Model {
	description: string;
	scientificName: string;
}